export default {
    addYearInterview: 'Gesprächstermin hinzufügen',
    editYearInterview: 'Gesprächstermin bearbeiten',
    deleteYearInterview: 'Gesprächstermin löschen',
    saveYearInterview: 'Gesprächstermin speichern',

    createYearInterviewSuccess: 'Gesprächstermin erfolgreich erstellt',
    createYearInterviewError: 'Fehler beim Erstellen des Gesprächstermins',

    editYearInterviewSuccess: 'Gesprächstermin erfolgreich bearbeitet',
    editYearInterviewError: 'Fehler beim Bearbeiten des Gesprächstermins',

    deleteYearInterviewText: 'Möchten Sie diesen Gesprächstermin wirklich löschen?',
    deleteYearInterviewSuccess: 'Gesprächstermin erfolgreich gelöscht',
    deleteYearInterviewError: 'Fehler beim Löschen des Gesprächstermins',

    presence: 'Präsenz',
    video: 'Video',
    digital: 'Digital',

    table: {
        city: 'Stadt',
        type: 'Gesprächsart',
        date: 'Datum',
    }
}